'use client';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Table } from '@mui/material';
import { style } from './basetable.style';
import { TypographyComponent } from '../typography/Typography';
import { BoxComponent } from '../box/Box';
export const BaseTable = ({
  tableCells,
  rows,
}: {
  rows: {
    qtyDesc: string;
    desc: string;
    unitDesc: string;
    itemPrice?: string;
    isLoyaltyApplied?: boolean;
    discountedPrice?: string;
    specialRequest?: string;
  }[];
  tableCells: {
    label: string;
    align: string;
  }[];
}) => {
  const handleValues = (val: string) => {
    const items = val.split(',').map((item) => item.trim());
    const result = [];
    let foundDefaultPizzaSide = false;
    for (const item of items) {
      if (item === 'Default Pizza Side') {
        foundDefaultPizzaSide = true;
        result.push({ value: item, isAfterDefaultPizzaSide: false });
      } else if (['Left Half', 'Right Half', 'Full'].includes(item)) {
        foundDefaultPizzaSide = false;
        result.push({ value: item, isAfterDefaultPizzaSide: false });
      } else if (item) {
        result.push({ value: item, isAfterDefaultPizzaSide: foundDefaultPizzaSide });
      }
    }

    return result;
  };

  const pathname = window.location.pathname;
  const checkoutRoute = pathname.includes('checkout');
  return (
    <div id="base-table">
      <TableContainer>
        <Table aria-label="spanning table">
          <TableHead>
            <TableRow>
              {tableCells?.map((cell, index) => (
                <TableCell
                  key={index}
                  sx={
                    index === tableCells.length - 1 && !checkoutRoute
                      ? style.lastCell
                      : index === tableCells.length - 2 && !checkoutRoute
                      ? style.secondCell
                      : !checkoutRoute
                      ? style.it
                      : index === tableCells.length - 1
                      ? style.finalHeading
                      : style.heading
                  }
                >
                  {cell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={style.tableBody}>
            {rows?.map((row, rowIndex) => {
              console.log('rows in table', row);
              return (
                <TableRow id="base-table__row" key={rowIndex} sx={style.tableRow}>
                  <TableCell id="base-table__item-name" sx={{ ...style.list, padding: '12px !important' }}>
                    {handleValues(row.desc)?.map((qty, i) =>
                      qty.value === 'Default Pizza Side' ? null : (
                        <TypographyComponent
                          key={i}
                          variant="subtitle2"
                          sx={
                            qty.isAfterDefaultPizzaSide
                              ? { ...style.modifier, ...style.afterDefaultPizzaSide }
                              : i === 0 && !checkoutRoute
                              ? style.item
                              : ['Left Half', 'Right Half', 'Full'].includes(qty.value)
                              ? style.modifierBold
                              : !checkoutRoute
                              ? style.modifier
                              : style.checkoutItem
                          }
                        >
                          {qty.value}
                        </TypographyComponent>
                      )
                    )}
                    {row.specialRequest && (
                      <BoxComponent>
                        <TypographyComponent
                          variant="body1"
                          sx={{
                            color: '#53575D',
                            fontSize: '12px',
                            fontWeight: { xs: 600, md: 500 },
                            wordWrap: 'break-word',
                            ml: '10px',
                          }}
                        >
                          Special Instructions
                        </TypographyComponent>
                        <TypographyComponent variant="subtitle2" sx={style.specialRequest}>
                          {row.specialRequest}
                        </TypographyComponent>
                      </BoxComponent>
                    )}
                  </TableCell>
                  <TableCell id="base-table__qty" sx={{ ...style.qtyli, padding: '12px !important' }}>
                    {handleValues(row.qtyDesc)?.map((qty, i) => (
                      <TypographyComponent
                        key={i}
                        variant="subtitle2"
                        sx={{
                          ...(i === 0 && !checkoutRoute ? style.item : !checkoutRoute ? style.qty : style.checkoutItem),
                          visibility: i !== 0 && (Number(qty.value) <= 1 || qty.value === '') ? 'hidden' : 'visible',
                          textAlign: 'center',
                        }}
                      >
                        {qty.value}
                      </TypographyComponent>
                    ))}
                  </TableCell>
                  <TableCell id="base-table__total-price" sx={{ ...style.unit, padding: '12px !important' }}>
                    {handleValues(row.unitDesc)?.map((unit, i) => (
                      <TypographyComponent
                        key={i}
                        variant="subtitle2"
                        sx={{
                          ...(i === 0 && !checkoutRoute
                            ? style.item
                            : !checkoutRoute
                            ? style.modifier
                            : style.checkoutItem),
                          visibility: i !== 0 && (unit.value === '0' || unit.value === '') ? 'hidden' : 'visible',
                        }}
                      >
                        {Number(row.discountedPrice) !== Number(unit.value) && i === 0 && !row.isLoyaltyApplied ? (
                          <>
                            <span style={{ textDecoration: 'line-through', color: '#888D95' }}>
                              {Number(unit.value)?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                              })}
                            </span>
                            &nbsp;&nbsp;{' '}
                            {Number(row.discountedPrice)?.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                          </>
                        ) : (
                          <>
                            {row.isLoyaltyApplied && i == 0 && Number(row.itemPrice) !== Number(unit.value) && (
                              <span style={{ textDecoration: 'line-through', color: '#888D95' }}>
                                {Number(row.itemPrice)?.toLocaleString('en-US', {
                                  style: 'currency',
                                  currency: 'USD',
                                })}
                              </span>
                            )}
                            &nbsp;&nbsp;{' '}
                            {Number(unit.value)?.toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                          </>
                        )}
                      </TypographyComponent>
                    ))}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
